module.exports = "/_next/static/images/F1-Target-Reached-Mixed-b588dcba25fd88b70875c45abf55fcf0.svg";